import type { CareState } from './CareRecord';
import type { TrickLevels } from '../world/Tricks';

/** Awards: earned once, shown in the inventory. Tests are pure functions of synced state. */
export interface Award {
  id: string;
  icon: string;
  name: string;
  hint: string;
  test: (care: CareState, tricks: TrickLevels, streak: number) => boolean;
}

export const AWARDS: Award[] = [
  { id: 'first-day', icon: '🌅', name: 'First day', hint: 'care for her one day', test: (c) => c.days.length >= 1 },
  { id: 'week', icon: '📅', name: 'One week', hint: '7-day streak', test: (_c, _t, s) => s >= 7 },
  { id: 'month', icon: '🏆', name: 'One month', hint: '30-day streak', test: (_c, _t, s) => s >= 30 },
  { id: 'hundred', icon: '💯', name: 'Hundred days', hint: '100 days of care', test: (c) => c.days.length >= 100 },
  { id: 'fetch-1', icon: '🎾', name: 'First fetch', hint: 'one fetch', test: (c) => c.fetches >= 1 },
  { id: 'fetch-25', icon: '🥎', name: 'Fetch fiend', hint: '25 fetches', test: (c) => c.fetches >= 25 },
  { id: 'trick-1', icon: '🎓', name: 'First trick', hint: 'master one trick', test: (_c, t) => Object.values(t).some((v) => v >= 5) },
  { id: 'trick-all', icon: '🎩', name: 'Show dog', hint: 'master every trick', test: (_c, t) => Object.values(t).every((v) => v >= 5) },
  { id: 'squirrel', icon: '🐿️', name: 'Squirrel!', hint: 'chase a visitor', test: (c) => c.visitorsChased >= 1 },
  { id: 'scoop', icon: '🧹', name: 'Clean yard', hint: 'scoop 10 times', test: (c) => (c.scoops ?? 0) >= 10 },
  { id: 'meals', icon: '🍖', name: 'Well fed', hint: '50 meals', test: (c) => c.feeds >= 50 },
  { id: 'cornhole', icon: '🎯', name: 'Cornhole', hint: 'sink the ball in the hole', test: (c) => (c.holes ?? 0) >= 1 },
  { id: 'cans', icon: '🥫', name: 'Sharpshooter', hint: 'knock 10 cans off the posts', test: (c) => (c.cans ?? 0) >= 10 },
  { id: 'catch-1', icon: '🥏', name: 'Air time', hint: 'catch the frisbee in the air', test: (c) => (c.catches ?? 0) >= 1 },
  { id: 'catch-10', icon: '🦅', name: 'Disc dog', hint: '10 frisbee catches', test: (c) => (c.catches ?? 0) >= 10 },
  { id: 'agility-1', icon: '🏃', name: 'Agility', hint: 'run the course once', test: (c) => (c.agilityRuns ?? 0) >= 1 },
  { id: 'agility-fast', icon: '⚡', name: 'Fast dog', hint: 'an agility run worth 48 points', test: (c) => (c.agilityBest ?? 0) >= 48 },
  { id: 'long-throw', icon: '🚀', name: 'Long arm', hint: 'a fetch from 8 m or more', test: (c) => (c.bestFetch ?? 0) >= 8 },
  { id: 'routine', icon: '🎪', name: 'Routine', hint: 'three different tricks in a row', test: (c) => (c.routines ?? 0) >= 1 },
  { id: 'squirrel-race', icon: '🏁', name: 'Squirrel racer', hint: 'catch up with the squirrel 3 times', test: (c) => (c.squirrelWins ?? 0) >= 3 },
];
